import ConfirmAction from '@/components/confirm-action';
import { Button } from '@/components/ui/button';
import { app_attachment_path } from '@/rails/routes';
import type { Attachment } from '@/types/platform';
import { router } from '@inertiajs/react';

interface RemoveAttachmentProps {
  appId: string;
  attachment: Attachment;
}

// Removes one attachment after a person confirms. The page stays where it is.
const RemoveAttachment = ({ appId, attachment }: RemoveAttachmentProps) => {
  return (
    <ConfirmAction
      title={`Remove ${attachment.filename}?`}
      description="The file is removed for good. This cannot be undone."
      confirmLabel="Remove"
      onConfirm={() =>
        router.delete(app_attachment_path(appId, attachment.id), { preserveScroll: true })
      }
    >
      <Button
        type="button"
        variant="ghost"
        size="sm"
        aria-label={`Remove ${attachment.filename}`}
        className="text-destructive hover:text-destructive"
      >
        Remove
      </Button>
    </ConfirmAction>
  );
};

export default RemoveAttachment;
